<template>
  <div class="indexAdvertisingadd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump">{{$t('lang.lab_indexAdBack')}}</el-button>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon" class="form">
        <el-form-item :label="$t('lang.lab_community')" prop="gardenId">
          <el-select v-if="changeIt==1" class="multiple-select" v-model="ruleForm.gardenIds"
            :placeholder="$t('lang.lab_selectCommunity')" multiple filterable clearable @change="change">
            <el-option :key=0 :label="$t('lang.lab_allVillage')" :value=0></el-option>
            <el-option v-for="item in gardens" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-else class="single-select" v-model="ruleForm.gardenId"
            :placeholder="$t('lang.lab_selectCommunity')">
            <el-option v-for="(item, index)  in garden" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverTitle')" prop='name'>
          <el-input maxlength="20" style="width:30%" class="select" v-model="ruleForm.name"
            :placeholder="$t('lang.lab_AllRemitTitle')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverPlat')" prop="style">
          <el-select v-model="ruleForm.style" placeholder>
            <el-option v-for="item in AllReStyle" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverSort')" prop="orderBy">
          <el-input-number :placeholder="$t('lang.lab_AdverSortText')" class="select"
            :label="$t('lang.lab_AdverSortText')" v-model="ruleForm.orderBy" controls-position="right"
            @change="handleChange" :min="1" :max="99"></el-input-number>
            <el-tooltip class="item" effect="light" :content=orderByTipFont placement="right">
              <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
            </el-tooltip>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverType')" prop="type">
          <el-select v-model="ruleForm.type" placeholder>
            <el-option v-for="item in indexAdType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <i @click="typeDialog = true" class="el-icon-warning tipIcon"></i>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverStatus')" prop="state">
          <el-select v-model="ruleForm.state" placeholder>
            <el-option v-for="item in indexAdStatus" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverBeginDate')" prop="beginTs">
          <div>
            <el-date-picker v-model="ruleForm.beginTs" type="date" value-format="timestamp"
              :placeholder="$t('lang.selecttimes')"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_AdverEndDate')" prop="endTs">
          <div>
            <el-date-picker v-model="ruleForm.endTs" type="date" value-format="timestamp"
              :placeholder="$t('lang.selecttimes')"></el-date-picker>
          </div>
        </el-form-item>
        <!-- 跳转链接1 -->
        <el-form-item :label="$t('lang.lab_AdverGoUrl')" prop="targetUri">
          <el-input style="width:50%" class="select" v-model="ruleForm.targetUri"
            :placeholder="$t('lang.lab_AdverWriteUrl')"></el-input>
        </el-form-item>
        <!-- 上传图片1 -->
        <el-form-item :label="$t('lang.lab_image')" prop="imageUri" ref="imageUri">
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears'
            @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
        <!-- 跳转链接2 -->
        <el-form-item v-if="this.ruleForm.type===402||this.ruleForm.type===403||this.ruleForm.type===406"
          :label="$t('lang.lab_AdverGoUrl2')" prop="targetUri2">
          <el-input style="width:50%" class="select" v-model="ruleForm.targetUri2"
            :placeholder="$t('lang.lab_AdverWriteUrl')"></el-input>
        </el-form-item>
        <!-- 上传图片2 -->
        <el-form-item v-if="this.ruleForm.type===402||this.ruleForm.type===403||this.ruleForm.type===406"
          :label="$t('lang.lab_image2')" prop="imageUri2" ref="imageUri2">
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList2' :clears='clears'
            @outputFile="getFile2" @removeFile='removeFile2'></upload-file>
        </el-form-item>
        <!-- 跳转链接3 -->
        <el-form-item :label="$t('lang.lab_AdverGoUrl3')" prop="targetUri3"
          v-if="this.ruleForm.type===403||this.ruleForm.type===406">
          <el-input style="width:50%" class="select" v-model="ruleForm.targetUri3"
            :placeholder="$t('lang.lab_AdverWriteUrl')"></el-input>
        </el-form-item>
        <!-- 上传图片3 -->
        <el-form-item v-if="this.ruleForm.type===403||this.ruleForm.type===406" :label="$t('lang.lab_image3')"
          prop="imageUri3" ref="imageUri3">
          <upload-file ref="uploading" :accept='accept' upTypes='1' :fileList='fileList3' :clears='clears'
            @outputFile="getFile3" @removeFile='removeFile3'></upload-file>
        </el-form-item>
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" :disabled="isCanUse" @click="onSubmit('ruleForm')">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
    <!-- 广告类型说明dialog -->
		<el-dialog title="广告类型说明" width="30%" :visible.sync="typeDialog"
			:close-on-click-modal='false'>
      <img style="display:inline-block;width: 100%; height: auto" :src="require('../../../assets/imgs/typeTip.jpg')"/>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:indexAdvertisingadd
   *@Description:首页广告添加编辑
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-07
   */
  import UploadFile from '../../../components/upload_file.vue'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      // eslint-disable-next-line
      var reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          // 当值为空时直接通过验证
          callback()
        } else if (value.length > 512) {
          callback(new Error(this.$i18n.t('lang.lab_BigLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          // 当值为空时直接通过验证
          callback()
        } else if (value.length > 512) {
          callback(new Error(this.$i18n.t('lang.lab_BigLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      var validatePass3 = (rule, value, callback) => {
        if (value === '') {
          // 当值为空时直接通过验证
          callback()
        } else if (value.length > 512) {
          callback(new Error(this.$i18n.t('lang.lab_BigLink')))
        } else {
          if (!reg.test(value)) {
            callback(new Error(this.$i18n.t('lang.lab_pleInputRLink')))
          }
          callback()
        }
      }
      return {
        orderByTipFont: '排序数字越大，广告越优先展示。', // 广告排序说明文案
        typeDialog: false, // 广告类型说明dialog
        accept: '.jpg, .jpeg, .png',
        fileList: [], // 文件列表
        fileList2: [], // 文件列表
        fileList3: [], // 文件列表
        clears: false, // 清空按钮
        isCanUse: true, // 保存按钮可用状态
        changeIt: '', // 添加是1   编辑是0
        id: '', // 广告id
        rules: {
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_AllRemitTitle'),
            trigger: 'blur'
          }],
          orderBy: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverPleaseSort'),
            trigger: 'blur'
          }],
          locationName: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverPleaseWriteUrlName'),
            trigger: 'blur'
          }],
          targetUri: [{
            required: false,
            validator: validatePass,
            trigger: 'blur'
          }],
          targetUri2: [{
            required: false,
            validator: validatePass2,
            trigger: 'blur'
          }],
          targetUri3: [{
            required: false,
            validator: validatePass3,
            trigger: 'blur'
          }],
          imageUri: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          imageUri2: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          imageUri3: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleaseUploadPhotograph'),
            trigger: 'change'
          }],
          beginTs: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverSelectBeginDate'),
            trigger: 'change'
          }],
          endTs: [{
            required: true,
            message: this.$i18n.t('lang.lab_AdverSelsetEndDate'),
            trigger: 'change'
          }]
        },
        editorOption: {
          // 富文本的类型
          theme: 'snow'
        },
        ruleForm: {
          gardenId: this.$store.getters.gardenId,
          gardenIds: [],
          state: 1, // 广告状态
          targetUri: '', // 跳转链接
          targetUri2: '', // 跳转链接
          targetUri3: '', // 跳转链接
          name: '', // 名称
          imageUri: '', // 图片链接
          imageUri2: '', // 图片链接
          imageUri3: '', // 图片链接
          fileList: [], // 上传文件集合
          fileList2: [], // 上传文件集合
          fileList3: [], // 上传文件集合
          type: 1, // 广告类型
          style: 0, // 广告平台
          beginTs: Date.parse(new Date()), // 开始时间
          endTs: Date.parse(new Date()), // 结束时间
          orderBy: '1' // 排序方式
        },
        oldsearchUnit: [],
        // gardens: [], // 小区集合
        garden: [], // 所选小区
        options: this.$i18n.t('lang.options'),
        detail: this.$i18n.t('lang.ownerApp'),
        AllReStyle: this.$i18n.t('lang.AllRemitSelect.AllReStyle'), // 广告平台下拉列表
        indexAdStatus: this.$i18n.t('lang.indexAdSelect.indexAdStatus'), // 广告状态下拉列表
        indexAdType: this.$i18n.t('lang.indexAdSelect.indexAdType') // 广告类型下拉列表
      }
    },
    components: {
      'upload-file': UploadFile
    },
    destroyed() {
      window.localStorage.setItem('syform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('sysaveData', JSON.stringify(this.saveData))
    },
    created() {
      // 获取广告id 有id是编辑  没有id是添加
      this.id = this.$route.query.id
      if (window.localStorage.getItem('syform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('syform'))
        if (this.ruleForm.imageUri) {
          this.fileList.push({
            name: '',
            url: this.ruleForm.imageUri
          })
        }
        if (this.ruleForm.imageUri2) {
          this.fileList2.push({
            name: '',
            url: this.ruleForm.imageUri2
          })
        }
        if (this.ruleForm.imageUri3) {
          this.fileList3.push({
            name: '',
            url: this.ruleForm.imageUri3
          })
        }
        if (window.localStorage.getItem('sysaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('sysaveData'))
        }
      } else {
        if (this.id) {
          this.ads()
          this.myGarden()

          this.changeIt = 0
        } else {
          // 添加
          this.changeIt = 1
          this.fileList = []
          this.fileList2 = []
          this.fileList3 = []
          // this.selectGarden()
        }
      }
    },
    computed: {
      ...mapGetters({
        gardens: 'userGardenList'
      })
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          console.log(tempRule === this.saveData)
          if (tempRule == this.saveData) {
            // 没变
            this.isCanUse = true
          } else {
            // 变了
            this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 获取组件值
      getFile(e) {
        this.ruleForm.imageUri = e
        this.$refs.imageUri.clearValidate()
      },
      // 移除图片
      removeFile(e) {
        this.fileList = []
        this.ruleForm.imageUri = ''
      },
      // 获取组件值
      getFile2(e) {
        this.ruleForm.imageUri2 = e
        this.$refs.imageUri2.clearValidate()
      },
      // 移除图片
      removeFile2(e) {
        this.fileList2 = []
        // this.ruleForm.imageUri2 = ''
      },
      // 获取组件值
      getFile3(e) {
        this.ruleForm.imageUri3 = e
        this.$refs.imageUri3.clearValidate()
      },
      // 移除图片
      removeFile3(e) {
        this.fileList3 = []
        this.ruleForm.imageUri3 = ''
      },
      ads() {
        let loading = this.$loading()
        this.$get(`/ads/${this.id}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              res.gardenId = res.gardenid
              this.ruleForm = res
              this.fileList.push({
                name: '',
                url: this.ruleForm.imageUri
              })
              if (this.ruleForm.imageUri2 != '') {
                this.fileList2.push({
                  name: '',
                  url: this.ruleForm.imageUri2
                })
              } else {
                this.fileList2 = []
                this.ruleForm.imageUri2 = ''
              }
              if (this.ruleForm.imageUri3 != '') {
                this.fileList3.push({
                  name: '',
                  url: this.ruleForm.imageUri3
                })
              } else {
                this.fileList3 = []
                this.ruleForm.imageUri3 = ''
              }
              this.saveData = JSON.stringify(this.ruleForm)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      handleChange(value) {
        console.log(value)
      },
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      submitUpload() {
        this.$refs.upload.submit()
      },
      // 返回
      jump() {
        this.$router.push({
          name: 'indexAdvertisingList'
        })
      },
      // 小区下拉
    myGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.garden = myGardens
    },
      // 小区下拉
      // selectGarden() {
      //   this.$get(`/gardens`).then(
      //     res => {
      //       if (res && res.errCode === 0) {
      //         this.gardens = res.list
      //       }
      //     },
      //     error => {
      //       this.$message.error(error)
      //     }
      //   )
      // },
      // 多选项
      change(val) {
        const allValues = []
        // 将全选"0"加入allValues
        allValues.push(0)
        for (const item of this.gardens) {
          allValues.push(item.id)
        }
        // 用来储存上一次选择的值，可进行对比
        const oldVal = this.oldsearchUnit.length === 1 ? this.oldsearchUnit[0] : []
        // 若选择全部
        if (val.includes(0)) {
          this.ruleForm.gardenIds = allValues
        }
        // 取消全部选中， 上次有， 当前没有， 表示取消全选
        if (oldVal.includes(0) && !val.includes(0)) {
          this.ruleForm.gardenIds = []
        }
        // 新老数据都有全部选中,那就说明除了全选以外的被选择，所以去掉全选
        if (oldVal.includes(0) && val.includes(0)) {
          const index = val.indexOf(0)
          val.splice(index, 1)
          this.ruleForm.gardenIds = val
        }
        // 全选未选，但是其他选项都全部选上了，则全选选上
        if (!oldVal.includes(0) && !val.includes(0)) {
          if (val.length === allValues.length - 1) {
            this.ruleForm.gardenIds = [0].concat(val)
          }
        }
        // 储存当前选择的最后结果 作为下次的老数据
        this.oldsearchUnit[0] = this.ruleForm.gardenIds
      },
      // 保存方法
      onSubmit(formName) {
        if (this.ruleForm.endTs < this.ruleForm.beginTs) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_AdverTimeTips')
          })
          return
        }
        // 添加
        if (this.changeIt == 1) {
          let gardenIds = [...this.ruleForm.gardenIds]
          if (gardenIds.includes(0)) {
            gardenIds = gardenIds.filter(id => id !== 0)
          }
          let params = {
            name: this.ruleForm.name,
            orderBy: this.ruleForm.orderBy,
            type: this.ruleForm.type,
            state: this.ruleForm.state,
            style: this.ruleForm.style,
            beginTs: this.ruleForm.beginTs,
            endTs: this.ruleForm.endTs,
            imageUri: this.ruleForm.imageUri,
            imageUri2: this.ruleForm.imageUri2,
            imageUri3: this.ruleForm.imageUri3,
            targetUri: this.ruleForm.targetUri,
            targetUri2: this.ruleForm.targetUri2,
            targetUri3: this.ruleForm.targetUri3,
            'garden[]': gardenIds.toString(),
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$post('/ads', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.eagleEye.addSucceed')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.pivot0')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'indexAdvertisingList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        } else if (this.changeIt == 0) {
          // 编辑
          let params = {
            name: this.ruleForm.name,
            orderBy: this.ruleForm.orderBy,
            type: this.ruleForm.type,
            state: this.ruleForm.state,
            style: this.ruleForm.style,
            beginTs: this.ruleForm.beginTs,
            endTs: this.ruleForm.endTs,
            imageUri: this.ruleForm.imageUri,
            imageUri2: this.ruleForm.imageUri2,
            imageUri3: this.ruleForm.imageUri3,
            targetUri: this.ruleForm.targetUri,
            targetUri2: this.ruleForm.targetUri2,
            targetUri3: this.ruleForm.targetUri3,
            shareFlag: this.ruleForm.gardenId
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.$patch(`/ads/${this.id}`, params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_modify_success')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.pivot0')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'indexAdvertisingList'
                  })
                  this.pageCount = 1
                } else {
                  this.$message({
                    type: 'success',
                    message: res.errMsg
                  })
                }
              })
            }
          })
        }
      },
      // 清空方法
      resetForm(formName) {
        this.clears = true
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.name = ''
        this.ruleForm.orderBy = '1'
        this.ruleForm.type = 1
        this.ruleForm.state = 1
        this.ruleForm.beginTs = Date.parse(new Date())
        this.ruleForm.endTs = Date.parse(new Date())
        this.fileList = []
        this.fileList2 = []
        this.fileList3 = []
        this.ruleForm.fileList = []
        this.ruleForm.fileList2 = []
        this.ruleForm.fileList3 = []
        this.ruleForm.imageUri = ''
        this.ruleForm.imageUri2 = ''
        this.ruleForm.imageUri3 = ''
        this.ruleForm.style = 0
        this.ruleForm.targetUri = ''
        this.ruleForm.targetUri2 = ''
        this.ruleForm.targetUri3 = ''
      }
    }
  }
</script>

<style lang="scss">
  .tipIcon{
    font-size: 20px;
    margin-left: 10px;
    vertical-align: middle;
  }
  .noStyle{
    border: none!important;
    padding: 0!important;
  }
  .noStyle:hover{
    background-color: #fff!important;
  }
</style>
